import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {RouterLink} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {InviteDialogComponent} from '@app/admin/invite-dialog/invite-dialog.component';
import {AuthService} from '@app/auth/auth.service';
import {Observable} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';

@Component({
    selector: 'frog-invite-users-button',
    templateUrl: './invite-users-button.component.html',
    styleUrls: ['./invite-users-button.component.scss'],
    imports: [MatButton, MatIcon, RouterLink, AsyncPipe],
})
export class InviteUsersButtonComponent implements OnInit {
    public client$: Observable<Client>;

    constructor(
        private clientService: ClientService,
        private authService: AuthService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.client$ = this.authService.user.pipe(
            filter((user) => {
                return user.hasPermission('frog_auth.change_user');
            }),
            switchMap((user) => this.clientService.client),
        );
    }

    openInviteDialog(clientId: string) {
        this.matDialog.open(InviteDialogComponent, {
            maxWidth: '900px',
            width: '100%',
            data: clientId,
        });
    }
}
